import { createCrudSlice } from '../createCrudSlice';
import alertsService from '@/services/alerts.service';

const { reducer, thunks } = createCrudSlice('alerts', alertsService);
export const { fetchList: fetchAlerts, createItem: createAlert, updateItem: updateAlert, deleteItem: deleteAlert } = thunks;
export default reducer;
